/**
 * API Configuration Constants
 * 
 * This module handles dynamic backend URL selection based on the current frontend hostname.
 * It ensures that the correct backend environment is used for each deployment environment.
 */

/** Current frontend hostname extracted from browser location */
const currentHost = window.location.hostname;

/**
 * Mapping of frontend hostnames to their corresponding backend URLs
 * 
 * Environment mappings:
 * - Development: cilantro3-dev-frontend-* → cilantro3-dev-backend-*
 * - QA: qa-cilantro-frontend → qa-cilantro-backend
 * - UAT: cilantrouat.mycompass.co.in → cilantrouat-appservices-backend
 * - Production: cilantro.mycompass.co.in → cilantro-appservices-backend-prd-*
 */
const backendUriMap: Record<string, string> = {
   // 'dev-cilantro-frontend.azurewebsites.net': 'https://dev-cilantro.azurewebsites.net',
  'cilantro3-dev-frontend-bvhwc9hvavhsa6cs.centralindia-01.azurewebsites.net': 'https://cilantro3-dev-backend-c9b4bhh9hdbxb2dn.centralindia-01.azurewebsites.net',
  //'cilantro3-qas-frontend-b6fsfdh6hgazg8fy.centralindia-01.azurewebsites.net':'https://cilantro3-qas-backend-h3evfgb0d5brdfgu.centralindia-01.azurewebsites.net',
  //'qa-cilantro-frontend.azurewebsites.net': 'https://qa-cilantro-backend.azurewebsites.net',
  'cilantrouat.mycompass.co.in': 'https://cilantrouat-appservices-backend.azurewebsites.net',
  //'cilantrouat.mycompass.co.in': 'https://cilantrouat-cr-appservices-frontend-ajccekcedzefevfq.centralindia-01.azurewebsites.net',
  'cilantro.mycompass.co.in': 'https://cilantro-appservices-backend-prd-g4dzftgyazdpg9cx.centralindia-01.azurewebsites.net',
  'cilantrouat-cr-appservices-frontend-ajccekcedzefevfq.centralindia-01.azurewebsites.net':'https://cilantrouat-cr-appservices-backend-chc0drewdgcdbad2.centralindia-01.azurewebsites.net'
};

/**
 * Primary backend API base URL
 * 
 * Dynamically selects the appropriate backend URL based on current hostname.
 * Falls back to development environment if no matching hostname is found.
 * 
 * @example
 * // When running on qa-cilantro-frontend.azurewebsites.net
 * // BASE_URL will be 'https://qa-cilantro-backend.azurewebsites.net'
 */

/** Environment override (if available) */
const envBaseUrl = typeof process !== 'undefined' && (process.env as any)?.AZURE_APP_BASE_URL
  ? String((process.env as any).AZURE_APP_BASE_URL).trim()
  : '';

  export const BASE_URL =
  Object.entries(backendUriMap).find(([key]) => currentHost.includes(key))?.[1] || 
  envBaseUrl 
  //'https://cilantro3-dev-backend-c9b4bhh9hdbxb2dn.centralindia-01.azurewebsites.net';  
  //'https://cilantrouat-appservices-backend.azurewebsites.net'
  //'https://cilantro-appservices-backend-prd-g4dzftgyazdpg9cx.centralindia-01.azurewebsites.net';
  //'https://qa-cilantro-backend.azurewebsites.net'
  //https://cilantrouat-cr-appservices-backend-chc0drewdgcdbad2.centralindia-01.azurewebsites.net

/** External API endpoint for testing and placeholder data */
export const JSON_PLACEHOLDER_URL = 'https://jsonplaceholder.typicode.com';

/** Current user ID retrieved from localStorage, defaults to 1 if not found */
export const USERID = localStorage.getItem('userid') || 1;

/** Default timeout for API requests in milliseconds (10 seconds) */
export const TIMEOUT = 10000;
